export class ArrayTools {
  static compareStringsAlphabeticalSort(a: string, b: string): number {
    return a.localeCompare(b, undefined, {
      sensitivity: 'variant',
      usage: 'sort',
    });
  }

  static removeFalsy<T>(array: Array<T | undefined | null>): T[] {
    return array.filter(n => n !== undefined && n !== null);
  }
}
